export const index = function (state) {
  return state.index;
};
